import React from "react";
import { connect } from "react-redux";
import { BloodUsage } from "../../components/BloodUsage";
import { DashboardHeader } from "../../components/Header";
import language from "../../language";
import { Tabs } from "../../components/Tabs";
// eslint-disable-next-line no-unused-vars

class HemovigilanceScreen extends React.Component {
  render() {
    const { haemovigilance } = language[this.props.defaultLanguage];
    return (
      <div className="card-body">
        <DashboardHeader title={haemovigilance} />
        <Tabs
          options={[
            // {
            //   title: language[this.props.defaultLanguage].new_record,
            //   data: (
            //     <NewUsage
            //       isForNominative
            //       // getData={this.getData.bind(this)}
            //       // {...this.state.selectedData}
            //     />
            //   ),
            // },
            {
              title: language[this.props.defaultLanguage].pending,
              data: <BloodUsage isForPending />,
            },
            {
              title: language[this.props.defaultLanguage].historical_data,
              data: <BloodUsage showDashboardCounts />,
            },
          ]}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(HemovigilanceScreen);
